let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("k5V2i")).then(() => parcelRequire('9XJab'));